import { SwPadComponent } from './sw-pad/sw-pad';
import { SwAppComponent } from './sw-app/sw-app';

// components imports

export const components: any[] = [
  // components export
  SwPadComponent,
  SwAppComponent,
];
